import React, { FC } from 'react';
import CodeEditorLayoutWithFiles from '../Smart/CodeEditor/CodeEditorLayoutWithFiles';

const CodeEditorPage: FC = () => (
	<div className="CodeEditorPage">
		<CodeEditorLayoutWithFiles
			field={{
				options: {
					html: '',
					css: '',
					js: '',
				},
			}}
			wrapperField=""
			parentField=""
			taskSlug=""
			pageView
			backButton
			taskId={null}
		/>
	</div>
);

export default CodeEditorPage;
